export interface LocalisationProps {
  value: string;
  i18nKey: string;
}

export type EnumLocalisation<T> = {
  [K in keyof T]: LocalisationProps;
};

/**
 * Creates a localisation mapping for an enum, associating each enum member with localisation data.
 * The enum items should be in the format KEY = 'KEY' where the enum value is a string form of the key.
 * The value can then be used for say, DB storage, and as the i18nKey for localisation.
 *
 * @template T - The enum type for which to create localisation.
 * @param {T} enumObj - The enum object for which localisation is being created.
 * @param {string} i18nNamespace - The namespace for internationalisation keys.
 * @returns {EnumLocalisation<T>} - A localisation mapping for the enum members.
 */
export function createLocalisation<T>(
  enumObj: any,
  i18nNamespace: string,
): EnumLocalisation<T> {
  const localisation: EnumLocalisation<T> = {} as EnumLocalisation<T>;

  Object.keys(enumObj).forEach((key: string): void => {
    const enumValue = enumObj[key];
    localisation[key as keyof T] = {
      value: enumValue,
      i18nKey: `${i18nNamespace}.${enumValue}`,
    };
  });

  return localisation;
}
